import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";
import axios from "axios";

function AadharMaskNew() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    account_no: "",
    holdername: "",
    ifsc_code: "",
  });
  const [img, setImg] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      account_no: "",
      holdername: "",
      ifsc_code: "",
      status: "",
      document_type: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://m5rseciddk.execute-api.ap-south-1.amazonaws.com/default/aadhar_qr_masking",
      headers: {
        "x-api-key": "WBrNDKymX69PJIjcHlJm92Etfz1xg9NN8bvk1vNp",
        // authorizationToken: "Pa3j51ewyST3nAR4",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true);
      })

      .catch(function (error) {
        setLoading(true);
        alert("Something went wrong with server");
        // console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div className="container containerBoreder " id="pan">
          <h2 className="pageTitle">Aadhar Masking</h2>
          <div className="row">
            <div className="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading ? (
              <div className="col-4">
                <button className="btn btn-primary" onClick={submit}>
                  Submit
                </button>
              </div>
            ) : (
              <ReactBootStrap.Spinner animation="border" />
            )}
          </div>
          <br />
          <table className="table">
            <tbody>
              <tr>
                <th>Status</th>
                <td> {cardData.status}</td>
              </tr>
              <tr>
                <tr>Masked Image:</tr>
                <br />
                <img
                  alt=""
                  className="imgBorder"
                  src={
                    cardData.hasOwnProperty("masking")
                      ? "data:image/png;base64," + cardData["masking"]
                      : ""
                  }
                ></img>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AadharMaskNew;
